import { render } from "./RedrawInformation.vue?vue&type=template&id=637be9a1&scoped=true"
import script from "./RedrawInformation.vue?vue&type=script&lang=js"
export * from "./RedrawInformation.vue?vue&type=script&lang=js"

import "./RedrawInformation.vue?vue&type=style&index=0&id=637be9a1&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../jiffyshirts/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.6_vue@3.5.6_typescript@5.8.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637be9a1"]])

export default __exports__